module.exports = __webpack_public_path__ + "static/media/Scene 19.13631e48.jpg";